import { planningStore } from "../store";

export function setSelectedGssCodes(gssCodes: string[]) {
  planningStore.selectedGssCodes = gssCodes;
}
